<app-page-list 
[data]="data" 
[columns]="columns" 
[queryService]="queryService" 
[canSearch]="false"
[canInsert]="false" 
[crud]="undefined"
[isRowClickable]="false"
[insertForm]="insertForm"
insertFormTitle="ReportNet" 
insertFormSize="full" 
[customClickFunction]="customClickFunction">
  <div filters>
    <app-filters-panel>
      <app-filters-group title="Prelievo" [form]="filters" [filtersGroup]="['dataPrelievo_greaterThanOrEqual', 'dataPrelievo_lessThanOrEqual']">
        <app-input-date name="dataPrelievo_greaterThanOrEqual" label="Dal" placeholder="GG/MM/AAAA" [form]="filters"></app-input-date>
        <app-input-date name="dataPrelievo_lessThanOrEqual" label="Al" placeholder="GG/MM/AAAA" [form]="filters"></app-input-date>
      </app-filters-group>
      <mat-divider class="mx-3"></mat-divider>
      <app-filters-group title="Analisi" [form]="filters" [filtersGroup]="['dataAnalisi_greaterThanOrEqual', 'dataAnalisi_lessThanOrEqual']">
        <app-input-date name="dataAnalisi_greaterThanOrEqual" label="Dal" placeholder="GG/MM/AAAA" [form]="filters"></app-input-date>
        <app-input-date name="dataAnalisi_lessThanOrEqual" label="Al" placeholder="GG/MM/AAAA" [form]="filters"></app-input-date>
      </app-filters-group>
      <mat-divider class="mx-3"></mat-divider>
      <app-filters-group title="Stato" [form]="filters" [filtersGroup]="['status_in']">
        <app-input-toggle-group name="status_in" [form]="filters" [options]="statusOptions"></app-input-toggle-group>
      </app-filters-group>
    </app-filters-panel>
  </div>
<!--   <div insert-form class="flex flex-column gap-2">

    <app-trasmissione-reportnet3 [form]="insertForm"></app-trasmissione-reportnet3>
    
    </div> -->
</app-page-list>
<br><br>
<mat-divider></mat-divider>
<br><br>
<mat-tab-group>
  <mat-tab label="Parametri Alert"> 
    <app-table *ngIf="datiParametriAlert; else noParametriAlert" matSort [data]="datiParametriAlert"
      [columns]="columnsParametriAlert" 
      [crud]="trasmissioneReportNetService"
      [showButtonInsert]="true"
      typeIconInsert="add"
      typeTitleInsert="Aggiungi"
      insertFormSize="full" 
      [insertForm]="insertForm"
      insertFormTitle="reportNet"
      (myDataEvent)="handleEvent($event)">
      <ng-content></ng-content>
      <div insert-form class="flex flex-column gap-2">

        <app-trasmissione-reportnet3 [form]="insertForm"></app-trasmissione-reportnet3>
        
        </div>
    </app-table>
    <ng-template #noParametriAlert>
      Nessun Dato da Visualizzare
    </ng-template>
  </mat-tab>
  <mat-tab label="Parametri Obbligatori Mancanti">
    <app-table *ngIf="datiParametriObbl; else noParametriObb" matSort [data]="datiParametriObbl" [columns]="columnsParametriObbl">
      <ng-content></ng-content>
    </app-table>
    <ng-template #noParametriObb>
      Nessun Dato da Visualizzare
    </ng-template>
  </mat-tab>
</mat-tab-group>

